export default "<span key>{{ key }}</span>\r\n<span value>{{ value }}</span>";